export default function Logo(): React.ReactElement {
  return (
    <svg width="136" height="40" viewBox="0 0 136 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>Anthropic</title>
      <g clipPath="url(#clip0_348_23)">
        <path
          d="M33.5486 16.0455H38.396V27.7514H41.4898V16.0455H46.3371V13.2486H33.5486V16.0455Z"
          fill="currentColor"
        />
        <path
          d="M28.0827 23.4005L21.5853 13.2486H18.0787V27.7514H21.0696V17.5994L27.567 27.7514H31.0734V13.2486H28.0827V23.4005Z"
          fill="currentColor"
        />
        <path
          d="M58.7131 19.029H51.9063V13.2486H48.8123V27.7514H51.9063V21.8259H58.7131V27.7514H61.8071V13.2486H58.7131V19.029Z"
          fill="currentColor"
        />
        <path
          d="M6.7548 13.2486L1 27.7514H4.21774L5.39469 24.7058H11.4154L12.5921 27.7514H15.8099L10.0551 13.2486H6.7548ZM6.43551 22.0124L8.40493 16.9157L10.3744 22.0124H6.43551Z"
          fill="currentColor"
        />
        <path
          d="M87.4458 13C83.2792 13 80.3297 16.1077 80.3297 20.5207C80.3297 24.8923 83.2792 28 87.4458 28C91.5917 28 94.5207 24.8923 94.5207 20.5207C94.5207 16.1077 91.5917 13 87.4458 13ZM87.4458 25.0994C85.0118 25.0994 83.5267 23.3591 83.5267 20.5207C83.5267 17.6409 85.0118 15.9006 87.4458 15.9006C89.8591 15.9006 91.3235 17.6409 91.3235 20.5207C91.3235 23.3591 89.8591 25.0994 87.4458 25.0994Z"
          fill="currentColor"
        />
        <path
          d="M130.7 22.8826C130.163 24.2914 129.091 25.0994 127.626 25.0994C125.192 25.0994 123.707 23.3591 123.707 20.5207C123.707 17.6409 125.192 15.9006 127.626 15.9006C129.091 15.9006 130.163 16.7086 130.7 18.1174H133.979C133.175 15.0097 130.761 13 127.626 13C123.46 13 120.51 16.1077 120.51 20.5207C120.51 24.8923 123.46 28 127.626 28C130.782 28 133.195 25.9696 134 22.8826H130.7Z"
          fill="currentColor"
        />
        <path d="M110.981 13.2486L116.735 27.7514H119.891L114.136 13.2486H110.981Z" fill="currentColor" />
        <path
          d="M104.463 13.2486H97.4084V27.7514H100.502V22.4889H104.463C107.742 22.4889 109.743 20.7486 109.743 17.8688C109.743 14.9889 107.742 13.2486 104.463 13.2486ZM104.318 19.692H100.502V16.0455H104.318C105.845 16.0455 106.649 16.6671 106.649 17.8688C106.649 19.0704 105.845 19.692 104.318 19.692Z"
          fill="currentColor"
        />
        <path
          d="M77.9575 17.6616C77.9575 14.9268 75.9568 13.2486 72.6772 13.2486H65.6229V27.7514H68.7169V22.0746H72.1614L75.2555 27.7514H78.6796L75.2534 21.6422C76.9731 20.9781 77.9575 19.5799 77.9575 17.6616ZM68.7169 16.0455H72.5328C74.0591 16.0455 74.8636 16.6049 74.8636 17.6616C74.8636 18.7183 74.0591 19.2777 72.5328 19.2777H68.7169V16.0455Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_348_23">
          <rect width="133" height="15" fill="white" transform="translate(1 13)" />
        </clipPath>
      </defs>
    </svg>
  )
}
